import Helper from './Helper';

class EqualHeight {
  constructor(config = {}) {
    const {
      elementSelector
    } = config;

    this.elements = document.querySelectorAll(elementSelector);
    this.elementsArray = Array.prototype.slice.call(this.elements);
    this.maxElementHeight = 0;
    
    if(this.elements){
      this.bindEvents();
    }
  }

  bindEvents() {

    this.getMaxHeight();

    window.addEventListener('resize', () => {
      this.getMaxHeight();
    });
  }

  getMaxHeight() {
    let maxHeight = 0;

    this.elementsArray.forEach(element => {
      let elementHeight = element.clientHeight;
      if ( elementHeight > maxHeight ) {
        maxHeight = elementHeight;
      }
    });

    this.maxElementHeight = maxHeight;

    this.elementsArray.forEach(element => {
      element.style.height = this.maxElementHeight+'px';
    });
  }

}

export default EqualHeight;
